import { useSidebarStore } from "./sidebarStore";

export const useSidebar = () => {
    const { isCollapsed, toggleCollapse, setCollapsed } = useSidebarStore();
    return { isCollapsed, toggleCollapse, setCollapsed };
};
